import type { ActivationLifecycle } from '@/infra/activation'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import type { SearchableJob } from '@/features/jobs/list/SearchableJob'
import { task } from 'mobx-task'
import type { UnreadCountFn } from '@/features/messages'
import { asAtom, toStream } from '@/utils/mobx-util'
import { computed } from 'mobx'
import { filterNonNil } from '@/utils/rx-util'
import { switchMap } from 'rxjs'
import type { PromptArchiveJobFn } from '@/features/jobs'

export class JobListItemViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()
  private readonly _getUnreadCount

  constructor(
    public readonly job: SearchableJob,
    unreadCount: UnreadCountFn,
    private readonly _promptArchiveJob: PromptArchiveJobFn,
  ) {
    this._getUnreadCount = asAtom(
      toStream(() => job.conversationId, true).pipe(
        filterNonNil(),
        switchMap(unreadCount),
      ),
      0,
    )
  }

  /**
   * Gets the unread messages count.
   */
  @computed get unreadCount() {
    return this.job.status === 'UnderConstruction' ? 0 : this._getUnreadCount()
  }

  /** @inheritDoc */
  activate() {
    this._lifecycle.activate()
  }

  /** @inheritDoc */
  deactivate() {
    this._lifecycle.deactivate()
  }

  /**
   * Prompts for job deletion.
   */
  promptDelete = task.resolved(async () => {
    await this._promptArchiveJob({
      id: this.job.id,
      displayName: () => this.job.displayName,
      signal: this._lifecycle.signal,
    })
  })
}
